module.exports = __webpack_public_path__ + "media/images/vector_marketplace-6d9880e6b21b01320b4a52fde917704a.png";